<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/JZB9aM/tc-custom/9780062098979.jpg?1728259311146" alt="This image is the cover for the book Purpose"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Purpose
      </h1>
      <p class="bookDescription body article font2">
        <p><i>Purpose</i> is Wyclef Jean’s powerful story of a life rooted in struggle, soul-searching, art, and survival.</p><p>In his own voice the multi-platinum musician and producer shares everything, from his childhood in Haiti to his rise to the top of the American music scene. For the first time ever, Wyclef reveals the behind-the-scenes story of the Fugees, including his partnership with Lauryn Hill and Pras Michel, the details of their award-winning album <i>The Score</i>, and the solo career that followed.</p><p>For fans of early Wyclef efforts like <i>The Carnival</i> or later albums like <i>From the Hut, To the Projects, To the Mansion</i>—and for fans of books like Jay-Z’s <i>Decoded </i>or <i>Russell Simmons</i>’ <i>Super Rich</i>—Wyclef’s <i>Purpose</i> is an inspiring, one-of-a-kind look at one of the world’s most talented artists.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Wyclef Jean, Anthony Bozza
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      HarperCollins
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3214ed33